const translations = {
  en: {
    nav: {
      about: "About",
      categories: "Categories",
      howItWorks: "How it works",
      faq: "FAQ",
      download: "Download the App",
    },
    hero: {
      label: "A Directory for Black & African Businesses, Events & Organizations",
      title: "Discover. Connect. Support.",
      subtitle: "A practical and easy to use app to find Black-owned businesses, organizations, and African cultural events near you. Available in English, French, Spanish, and Portuguese.",
      cta: "Download the App",
      secondary: "Learn More",
    },
    about: {
      label: "About Ascifiw3",
      title: "A Digital Directory for Black & African Communities",
      description: "Ascifiw3 Network is a digital directory that connects you to Black-owned businesses, organizations, and African cultural events. Available in four languages, the app is designed to break language barriers and make it easier for communities across the globe to discover and support each other.",
      mission: "Our mission is to strengthen community bonds through economic empowerment, cultural celebration, and digital accessibility.",
    },
    categories: {
      label: "Directory Categories",
      title: "What You Can Find",
      subtitle: "The directory organizes businesses, organizations, and events into categories to help you find exactly what you need.",
      items: {
        food: "Food & Dining",
        fashion: "Fashion & Style",
        beauty: "Beauty & Wellness",
        arts: "Arts & Culture",
        services: "Professional Services",
      },
    },
    howItWorks: {
      label: "How it works",
      title: "Three Simple Steps",
      steps: [
        { title: "Download", description: "Get the Ascifiw3 app from the App Store or Google Play." },
        { title: "Register", description: "Browse businesses, organizations, and events by category, location, or language." },
        { title: "Connect", description: "Support businesses, attend events, join organizations, and grow the community." },
      ],
    },
    faq: {
      label: "FAQ",
      title: "Frequently Asked Questions",
      items: [
        {
          question: "What is this app about?",
          answer: "This app connects Black and African entrepreneurs, organizations, events, and community members in one space designed for discovery, networking, and collaboration. It is built to help people find opportunities, support businesses, and create meaningful connections.",
        },
        {
          question: "Who is the app for?",
          answer: "The app is for people looking for/to discover Black and African businesses, projects, and events in one place. It's for Black and African entrepreneurs, business owners, creatives, organizations, event organizers, and people who want to support, get involved and engage with the community in order to shape one common vision of self-determination with 3 pillars at its foundation:\n\n- Autonomy: You are in control of your actions.\n- Competence: You are capable and effective.\n- Relationships / Belonging: It's through mutual support that we create a belonging.",
        },
        {
          question: "Can I promote my business or event on the app?",
          answer: "Yes, businesses, organizations, and event organizers can create a presence on the platform to increase visibility and reach the right audience. The goal is not just promotion, but helping people connect, collaborate, and take action together.",
        },
        {
          question: "Is the app only for entrepreneurs?",
          answer: "No, the app is not limited to entrepreneurs. It is also for users who want to discover Black-owned businesses, attend events, join initiatives, and support projects within the African and diaspora community.",
        },
        {
          question: "What can I do inside the app?",
          answer: "You can discover businesses and events, connect with other users, explore community opportunities, and engage with projects that matter to you. The platform is designed to make community interaction easier and more useful from the first visit.",
        },
        {
          question: "Do I need to pay to join?",
          answer: "Joining is free for all users. For professionals, it depends on the type of activity:\n\n- Business and Organization registration: 3 months free, then approximately \u20AC80 per year\n- Event listing: starting from \u20AC26\n- Verified checkmark: approximately \u20AC100 one-time (includes a sample/invitation to test the offer), then approximately \u20AC80 per year",
        },
        {
          question: "How do I get started?",
          answer: "Download the app, create your profile, and start exploring businesses, events, and people that match your interests.",
        },
        {
          question: "Is the app available internationally?",
          answer: "Yes.",
        },
        {
          question: "Is this app inclusive?",
          answer: "Yes, the app celebrates Black and African excellence through positive community-building and connection.",
        },
        {
          question: "How can I stay updated?",
          answer: "Anybody can sign up for updates, or follow our social channels to hear about launch news, new features, and upcoming partnerships.",
        },
      ],
    },
    newsletter: {
      label: "Stay Connected",
      title: "Get Updates",
      subtitle: "Sign up to receive news about the app, new features, and community updates.",
      placeholder: "Enter your email",
      button: "Subscribe",
      success: "You're on the list!",
      duplicate: "You're already subscribed!",
    },
    downloadApp: {
      title: "Get the App",
      subtitle: "Download Ascifiw3 Network and start discovering Black-owned businesses, organizations, and African cultural events.",
      cta: "Download for iOS",
      ctaAndroid: "Download for Android",
    },
    footer: {
      tagline: "A directory for Black & African businesses, organizations, and events. Available in four languages.",
      links: {
        about: "About",
        privacy: "Privacy",
        terms: "Terms",
        contact: "Contact Us",
      },
      copyright: "Ascifiw3 Network. All rights reserved.",
    },
  },
  fr: {
    nav: {
      about: "À Propos",
      categories: "Catégories",
      howItWorks: "Comment ça marche",
      faq: "FAQ",
      download: "Télécharger l'App",
    },
    hero: {
      label: "Un répertoire d'entreprises, événements et organisations afrodescendants et africains",
      title: "Découvrez. Connectez. Soutenez.",
      subtitle: "Une application pratique et facile à utiliser pour trouver des entreprises, organisations et événements culturels africains près de chez vous. Disponible en anglais, français, espagnol et portugais.",
      cta: "Télécharger l'App",
      secondary: "En savoir plus",
    },
    about: {
      label: "À Propos d'Ascifiw3",
      title: "Un répertoire numérique pour les communautés noires et africaines",
      description: "Ascifiw3 Network est un répertoire numérique qui vous connecte aux entreprises, organisations et événements culturels africains. Disponible en quatre langues, l'application est conçue pour briser les barrières linguistiques et faciliter la découverte et le soutien mutuel entre communautés à travers le monde.",
      mission: "Notre mission est de renforcer les liens communautaires par l'autonomisation économique, la célébration culturelle et l'accessibilité numérique.",
    },
    categories: {
      label: "Catégories du répertoire",
      title: "Ce que vous pouvez trouver",
      subtitle: "Le répertoire organise les entreprises, organisations et événements en catégories pour vous aider à trouver exactement ce dont vous avez besoin.",
      items: {
        food: "Restauration",
        fashion: "Mode & Style",
        beauty: "Beauté & Bien-être",
        arts: "Arts & Culture",
        services: "Services Professionnels",
      },
    },
    howItWorks: {
      label: "Comment ça marche",
      title: "Trois étapes simples",
      steps: [
        { title: "Télécharger", description: "Obtenez l'application Ascifiw3 sur l'App Store ou Google Play." },
        { title: "S'inscrire", description: "Parcourez les entreprises, organisations et événements par catégorie, lieu ou langue." },
        { title: "Connecter", description: "Soutenez les entreprises, participez aux événements, rejoignez des organisations et développez la communauté." },
      ],
    },
    faq: {
      label: "FAQ",
      title: "Questions Fréquentes",
      items: [
        {
          question: "De quoi parle cette application ?",
          answer: "Cette application connecte les entrepreneurs, organisations, événements et membres de la communauté afrodescendants et africains dans un espace conçu pour la découverte, le réseautage et la collaboration. Elle est construite pour aider les gens à trouver des opportunités, soutenir des entreprises et créer des connexions significatives.",
        },
        {
          question: "À qui s'adresse l'application ?",
          answer: "L'application s'adresse aux personnes qui cherchent à découvrir des entreprises, projets et événements afrodescendants et africains en un seul endroit. Elle est pour les entrepreneurs, propriétaires d'entreprises, créatifs, organisations, organisateurs d'événements afrodescendants et africains, et les personnes qui veulent soutenir, s'impliquer et s'engager avec la communauté afin de façonner une vision commune d'autodétermination avec 3 piliers à sa fondation :\n\n- Autonomie : Vous êtes en contrôle de vos actions.\n- Compétence : Vous êtes capable et efficace.\n- Relations / Appartenance : C'est par le soutien mutuel que nous créons un sentiment d'appartenance.",
        },
        {
          question: "Puis-je promouvoir mon entreprise ou événement sur l'application ?",
          answer: "Oui, les entreprises, organisations et organisateurs d'événements peuvent créer une présence sur la plateforme pour augmenter leur visibilité et atteindre le bon public. L'objectif n'est pas seulement la promotion, mais d'aider les gens à se connecter, collaborer et agir ensemble.",
        },
        {
          question: "L'application est-elle réservée aux entrepreneurs ?",
          answer: "Non, l'application n'est pas limitée aux entrepreneurs. Elle est aussi pour les utilisateurs qui veulent découvrir des entreprises appartenant à des Noirs, assister à des événements, rejoindre des initiatives et soutenir des projets au sein de la communauté africaine et de la diaspora.",
        },
        {
          question: "Que puis-je faire dans l'application ?",
          answer: "Vous pouvez découvrir des entreprises et événements, vous connecter avec d'autres utilisateurs, explorer des opportunités communautaires et vous engager dans des projets qui comptent pour vous. La plateforme est conçue pour rendre l'interaction communautaire plus facile et utile dès la première visite.",
        },
        {
          question: "Dois-je payer pour m'inscrire ?",
          answer: "L'inscription est gratuite pour tous les utilisateurs. Pour les professionnels, cela dépend du type d'activité :\n\n- Inscription entreprise et organisation : 3 mois gratuits, puis environ 80\u20AC par an\n- Publication d'événement : à partir de 26\u20AC\n- Badge vérifié : environ 100\u20AC une fois (inclut un échantillon/invitation pour tester l'offre), puis environ 80\u20AC par an",
        },
        {
          question: "Comment commencer ?",
          answer: "Téléchargez l'application, créez votre profil et commencez à explorer les entreprises, événements et personnes qui correspondent à vos intérêts.",
        },
        {
          question: "L'application est-elle disponible à l'international ?",
          answer: "Oui.",
        },
        {
          question: "Cette application est-elle inclusive ?",
          answer: "Oui, l'application célèbre l'excellence noire et africaine à travers la construction communautaire positive et la connexion.",
        },
        {
          question: "Comment rester informé ?",
          answer: "Tout le monde peut s'inscrire aux mises à jour ou suivre nos réseaux sociaux pour connaître les nouvelles du lancement, les nouvelles fonctionnalités et les partenariats à venir.",
        },
      ],
    },
    newsletter: {
      label: "Restez connecté",
      title: "Recevez les nouvelles",
      subtitle: "Inscrivez-vous pour recevoir des nouvelles sur l'application, les nouvelles fonctionnalités et les mises à jour communautaires.",
      placeholder: "Entrez votre email",
      button: "S'abonner",
      success: "Vous êtes inscrit !",
      duplicate: "Vous êtes déjà abonné !",
    },
    downloadApp: {
      title: "Obtenez l'application",
      subtitle: "Téléchargez Ascifiw3 Network et commencez à découvrir des entreprises, organisations et événements culturels africains.",
      cta: "Télécharger pour iOS",
      ctaAndroid: "Télécharger pour Android",
    },
    footer: {
      tagline: "Un répertoire d'entreprises, organisations et événements afrodescendants et africains. Disponible en quatre langues.",
      links: {
        about: "À Propos",
        privacy: "Confidentialité",
        terms: "Conditions",
        contact: "Contactez-nous",
      },
      copyright: "Ascifiw3 Network. Tous droits réservés.",
    },
  },
  es: {
    nav: {
      about: "Acerca de",
      categories: "Categorias",
      howItWorks: "Como funciona",
      faq: "FAQ",
      download: "Descargar la App",
    },
    hero: {
      label: "Un directorio de empresas, eventos y organizaciones negras y africanas",
      title: "Descubre. Conecta. Apoya.",
      subtitle: "Una aplicacion multilingue para encontrar negocios, organizaciones y eventos culturales africanos cerca de ti. Disponible en ingles, frances, espanol y portugues.",
      cta: "Descargar la App",
      secondary: "Saber mas",
    },
    about: {
      label: "Acerca de Ascifiw3",
      title: "Un directorio digital para las comunidades negras y africanas",
      description: "Ascifiw3 Network es un directorio digital que te conecta con empresas, organizaciones y eventos culturales africanos. Disponible en cuatro idiomas, la aplicacion esta disenada para romper las barreras del idioma y facilitar que las comunidades de todo el mundo se descubran y apoyen mutuamente.",
      mission: "Nuestra mision es fortalecer los lazos comunitarios a traves del empoderamiento economico, la celebracion cultural y la accesibilidad digital.",
    },
    categories: {
      label: "Categorias del directorio",
      title: "Lo que puedes encontrar",
      subtitle: "El directorio organiza empresas, organizaciones y eventos en categorias para ayudarte a encontrar exactamente lo que necesitas.",
      items: {
        food: "Gastronomia",
        fashion: "Moda y Estilo",
        beauty: "Belleza y Bienestar",
        arts: "Arte y Cultura",
        services: "Servicios Profesionales",
      },
    },
    howItWorks: {
      label: "Como funciona",
      title: "Tres pasos simples",
      steps: [
        { title: "Descargar", description: "Obtiene la app Ascifiw3 en App Store o Google Play." },
        { title: "Registrarse", description: "Navega por empresas, organizaciones y eventos por categoria, ubicacion o idioma." },
        { title: "Conectar", description: "Apoya empresas, asiste a eventos, unete a organizaciones y crece la comunidad." },
      ],
    },
    faq: {
      label: "FAQ",
      title: "Preguntas Frecuentes",
      items: [
        {
          question: "De que trata esta aplicacion?",
          answer: "Esta aplicacion conecta a emprendedores, organizaciones, eventos y miembros de la comunidad negra y africana en un espacio disenado para el descubrimiento, el networking y la colaboracion. Esta construida para ayudar a las personas a encontrar oportunidades, apoyar negocios y crear conexiones significativas.",
        },
        {
          question: "Para quien es la aplicacion?",
          answer: "La aplicacion es para personas que buscan descubrir negocios, proyectos y eventos negros y africanos en un solo lugar. Es para emprendedores, propietarios de negocios, creativos, organizaciones, organizadores de eventos negros y africanos, y personas que quieren apoyar, involucrarse y participar en la comunidad para formar una vision comun de autodeterminacion con 3 pilares en su fundacion:\n\n- Autonomia: Tu tienes el control de tus acciones.\n- Competencia: Eres capaz y eficaz.\n- Relaciones / Pertenencia: Es a traves del apoyo mutuo que creamos un sentido de pertenencia.",
        },
        {
          question: "Puedo promocionar mi negocio o evento en la aplicacion?",
          answer: "Si, las empresas, organizaciones y organizadores de eventos pueden crear una presencia en la plataforma para aumentar su visibilidad y llegar al publico adecuado. El objetivo no es solo la promocion, sino ayudar a las personas a conectarse, colaborar y actuar juntas.",
        },
        {
          question: "La aplicacion es solo para emprendedores?",
          answer: "No, la aplicacion no se limita a emprendedores. Tambien es para usuarios que quieren descubrir negocios de propietarios negros, asistir a eventos, unirse a iniciativas y apoyar proyectos dentro de la comunidad africana y de la diaspora.",
        },
        {
          question: "Que puedo hacer dentro de la aplicacion?",
          answer: "Puedes descubrir negocios y eventos, conectarte con otros usuarios, explorar oportunidades comunitarias y participar en proyectos que te importan. La plataforma esta disenada para hacer la interaccion comunitaria mas facil y util desde la primera visita.",
        },
        {
          question: "Necesito pagar para unirme?",
          answer: "Unirse es gratis para todos los usuarios. Para profesionales, depende del tipo de actividad:\n\n- Registro de empresa y organizacion: 3 meses gratis, luego aproximadamente 80\u20AC por ano\n- Publicacion de evento: desde 26\u20AC\n- Insignia verificada: aproximadamente 100\u20AC una vez (incluye una muestra/invitacion para probar la oferta), luego aproximadamente 80\u20AC por ano",
        },
        {
          question: "Como empiezo?",
          answer: "Descarga la aplicacion, crea tu perfil y comienza a explorar negocios, eventos y personas que coincidan con tus intereses.",
        },
        {
          question: "La aplicacion esta disponible internacionalmente?",
          answer: "Si.",
        },
        {
          question: "Es esta aplicacion inclusiva?",
          answer: "Si, la aplicacion celebra la excelencia negra y africana a traves de la construccion comunitaria positiva y la conexion.",
        },
        {
          question: "Como puedo mantenerme actualizado?",
          answer: "Cualquiera puede registrarse para recibir actualizaciones o seguir nuestros canales sociales para conocer noticias de lanzamiento, nuevas funciones y proximas alianzas.",
        },
      ],
    },
    newsletter: {
      label: "Mantente conectado",
      title: "Recibe novedades",
      subtitle: "Registrate para recibir noticias sobre la aplicacion, nuevas funciones y actualizaciones de la comunidad.",
      placeholder: "Ingresa tu email",
      button: "Suscribirse",
      success: "Estas en la lista!",
      duplicate: "Ya estas suscrito!",
    },
    downloadApp: {
      title: "Obtiene la aplicacion",
      subtitle: "Descarga Ascifiw3 Network y comienza a descubrir empresas, organizaciones y eventos culturales africanos.",
      cta: "Descargar para iOS",
      ctaAndroid: "Descargar para Android",
    },
    footer: {
      tagline: "Un directorio de empresas, organizaciones y eventos negros y africanos. Disponible en cuatro idiomas.",
      links: {
        about: "Acerca de",
        privacy: "Privacidad",
        terms: "Términos",
        contact: "Contáctenos",
      },
      copyright: "Ascifiw3 Network. Todos los derechos reservados.",
    },
  },
  pt: {
    nav: {
      about: "Sobre",
      categories: "Categorias",
      howItWorks: "Como funciona",
      faq: "FAQ",
      download: "Baixar o App",
    },
    hero: {
      label: "Um diretorio de empresas, eventos e organizacoes negras e africanas",
      title: "Descubra. Conecte. Apoie.",
      subtitle: "Um aplicativo multilingue para encontrar empresas, organizacoes e eventos culturais africanos perto de voce. Disponivel em ingles, frances, espanhol e portugues.",
      cta: "Baixar o App",
      secondary: "Saiba mais",
    },
    about: {
      label: "Sobre Ascifiw3",
      title: "Um diretorio digital para comunidades negras e africanas",
      description: "Ascifiw3 Network e um diretorio digital que conecta voce a empresas, organizacoes e eventos culturais africanos. Disponivel em quatro idiomas, o aplicativo foi projetado para quebrar barreiras linguisticas e facilitar que comunidades ao redor do mundo se descubram e apoiem mutuamente.",
      mission: "Nossa missao e fortalecer os lacos comunitarios por meio do empoderamento economico, celebracao cultural e acessibilidade digital.",
    },
    categories: {
      label: "Categorias do diretorio",
      title: "O que voce pode encontrar",
      subtitle: "O diretorio organiza empresas, organizacoes e eventos em categorias para ajuda-lo a encontrar exatamente o que precisa.",
      items: {
        food: "Gastronomia",
        fashion: "Moda e Estilo",
        beauty: "Beleza e Bem-estar",
        arts: "Arte e Cultura",
        services: "Servicos Profissionais",
      },
    },
    howItWorks: {
      label: "Como funciona",
      title: "Tres passos simples",
      steps: [
        { title: "Baixar", description: "Obtenha o app Ascifiw3 na App Store ou Google Play." },
        { title: "Registrar-se", description: "Navegue por empresas, organizacoes e eventos por categoria, local ou idioma." },
        { title: "Conectar", description: "Apoie empresas, participe de eventos, junte-se a organizacoes e cresca a comunidade." },
      ],
    },
    faq: {
      label: "FAQ",
      title: "Perguntas Frequentes",
      items: [
        {
          question: "Sobre o que e este aplicativo?",
          answer: "Este aplicativo conecta empreendedores, organizacoes, eventos e membros da comunidade negra e africana em um espaco projetado para descoberta, networking e colaboracao. Foi construido para ajudar as pessoas a encontrar oportunidades, apoiar negocios e criar conexoes significativas.",
        },
        {
          question: "Para quem e o aplicativo?",
          answer: "O aplicativo e para pessoas que buscam descobrir negocios, projetos e eventos negros e africanos em um so lugar. E para empreendedores, proprietarios de negocios, criativos, organizacoes, organizadores de eventos negros e africanos, e pessoas que querem apoiar, se envolver e participar da comunidade para moldar uma visao comum de autodeterminacao com 3 pilares em sua fundacao:\n\n- Autonomia: Voce esta no controle de suas acoes.\n- Competencia: Voce e capaz e eficaz.\n- Relacoes / Pertencimento: E atraves do apoio mutuo que criamos um sentimento de pertencimento.",
        },
        {
          question: "Posso promover meu negocio ou evento no aplicativo?",
          answer: "Sim, empresas, organizacoes e organizadores de eventos podem criar uma presenca na plataforma para aumentar a visibilidade e alcancar o publico certo. O objetivo nao e apenas promocao, mas ajudar as pessoas a se conectar, colaborar e agir juntas.",
        },
        {
          question: "O aplicativo e apenas para empreendedores?",
          answer: "Nao, o aplicativo nao se limita a empreendedores. Tambem e para usuarios que querem descobrir negocios de proprietarios negros, participar de eventos, juntar-se a iniciativas e apoiar projetos dentro da comunidade africana e da diaspora.",
        },
        {
          question: "O que posso fazer dentro do aplicativo?",
          answer: "Voce pode descobrir negocios e eventos, conectar-se com outros usuarios, explorar oportunidades comunitarias e se envolver com projetos que importam para voce. A plataforma foi projetada para tornar a interacao comunitaria mais facil e util desde a primeira visita.",
        },
        {
          question: "Preciso pagar para participar?",
          answer: "Participar e gratuito para todos os usuarios. Para profissionais, depende do tipo de atividade:\n\n- Registro de empresa e organizacao: 3 meses gratis, depois aproximadamente 80\u20AC por ano\n- Publicacao de evento: a partir de 26\u20AC\n- Selo verificado: aproximadamente 100\u20AC uma vez (inclui uma amostra/convite para testar a oferta), depois aproximadamente 80\u20AC por ano",
        },
        {
          question: "Como comecar?",
          answer: "Baixe o aplicativo, crie seu perfil e comece a explorar negocios, eventos e pessoas que correspondam aos seus interesses.",
        },
        {
          question: "O aplicativo esta disponivel internacionalmente?",
          answer: "Sim.",
        },
        {
          question: "Este aplicativo e inclusivo?",
          answer: "Sim, o aplicativo celebra a excelencia negra e africana atraves da construcao comunitaria positiva e da conexao.",
        },
        {
          question: "Como posso me manter atualizado?",
          answer: "Qualquer pessoa pode se inscrever para receber atualizacoes ou seguir nossos canais sociais para saber sobre noticias de lancamento, novos recursos e proximas parcerias.",
        },
      ],
    },
    newsletter: {
      label: "Fique conectado",
      title: "Receba novidades",
      subtitle: "Cadastre-se para receber noticias sobre o aplicativo, novos recursos e atualizacoes da comunidade.",
      placeholder: "Digite seu email",
      button: "Inscrever-se",
      success: "Voce esta na lista!",
      duplicate: "Voce ja esta inscrito!",
    },
    downloadApp: {
      title: "Obtenha o aplicativo",
      subtitle: "Baixe o Ascifiw3 Network e comece a descobrir empresas, organizacoes e eventos culturais africanos.",
      cta: "Baixar para iOS",
      ctaAndroid: "Baixar para Android",
    },
    footer: {
      tagline: "Um diretorio de empresas, organizacoes e eventos negros e africanos. Disponivel em quatro idiomas.",
      links: {
        about: "Sobre",
        privacy: "Privacidade",
        terms: "Termos",
        contact: "Entre em Contato",
      },
      copyright: "Ascifiw3 Network. Todos os direitos reservados.",
    },
  },
};

export default translations;
